window.ACTICLEAR_MEDIA = {
  "capturedAt": "2026-09-07T00:34:01.860813+00:00",
  "products": {
    "compact": [
      {
        "id": "compact-0.5lb",
        "type": "image",
        "src": "assets/media/compact-0.5lb-restored.svg",
        "alt": "compact 0.5lb package front",
        "variantId": 49913176064246,
        "caption": "0.5lb package. Cap edge restored; original label retained.",
        "provenance": "commercial-restoration",
        "width": 1600,
        "height": 1720,
        "originalSource": "assets/media/compact-0.5lb-listing.jpg",
        "originalSourceProvenance": "supplied-amazon-listing-image",
        "restoration": "AI-generated cap edge only; original JPEG label and body embedded unchanged."
      },
      {
        "id": "compact-1lb",
        "type": "image",
        "src": "assets/media/compact-1lb-listing.jpg",
        "alt": "compact 1lb package front",
        "variantId": 49913176097014,
        "caption": "1lb package shown. Supplied ActiClear listing image.",
        "provenance": "supplied-amazon-listing-image",
        "width": 1600,
        "height": 1600
      },
      {
        "id": "compact-2lb",
        "type": "image",
        "src": "assets/media/compact-2lb-listing.jpg",
        "alt": "compact 2lb package front",
        "variantId": 49913176129782,
        "caption": "2lb package shown. Supplied ActiClear listing image.",
        "provenance": "supplied-amazon-listing-image",
        "width": 1600,
        "height": 1600
      },
      {
        "id": "compact-4lb",
        "type": "image",
        "src": "assets/media/compact-4lb-listing.jpg",
        "alt": "compact 4lb package front",
        "variantId": 50113861353718,
        "caption": "4lb package shown. Supplied ActiClear listing image.",
        "provenance": "supplied-amazon-listing-image",
        "width": 1600,
        "height": 1600
      },
      {
        "id": "pond-editorial",
        "type": "image",
        "src": "assets/media/pond-editorial.png",
        "alt": "pond environmental editorial scene",
        "caption": "Illustrative pond setting. Original generated editorial image; not a product demonstration.",
        "provenance": "original-generated-environment",
        "width": 1536,
        "height": 1024
      }
    ],
    "large": [
      {
        "id": "large-5lb",
        "type": "image",
        "src": "assets/media/large-5lb-listing.jpg",
        "alt": "large 5lb package front",
        "variantId": 49913279021302,
        "caption": "5lb package shown. Supplied ActiClear listing image. Original listing artwork; historical upper-band wordmark.",
        "provenance": "supplied-amazon-listing-image",
        "width": 2000,
        "height": 2000
      },
      {
        "id": "large-15lb",
        "type": "image",
        "src": "assets/media/large-15lb-listing.jpg",
        "alt": "large 15lb package front",
        "variantId": 49913279054070,
        "caption": "15lb package shown. Supplied ActiClear listing image. This 15lb format is shown in a carton.",
        "provenance": "supplied-amazon-listing-image",
        "width": 2000,
        "height": 2000
      },
      {
        "id": "pond-editorial",
        "type": "image",
        "src": "assets/media/pond-editorial.png",
        "alt": "pond environmental editorial scene",
        "caption": "Illustrative pond setting. Original generated editorial image; not a product demonstration.",
        "provenance": "original-generated-environment",
        "width": 1536,
        "height": 1024
      }
    ],
    "oil": [
      {
        "id": "oil-11oz",
        "type": "image",
        "src": "assets/media/oil-11oz-listing.jpg",
        "alt": "oil 11oz package front",
        "variantId": 49913164497142,
        "caption": "11oz package shown. Supplied ActiClear listing image.",
        "provenance": "supplied-amazon-listing-image",
        "width": 1600,
        "height": 1600
      },
      {
        "id": "oil-22oz",
        "type": "image",
        "src": "assets/media/oil-22oz-listing.jpg",
        "alt": "oil 22oz package front",
        "variantId": 49913164529910,
        "caption": "22oz package shown. Supplied ActiClear listing image.",
        "provenance": "supplied-amazon-listing-image",
        "width": 2000,
        "height": 2000
      },
      {
        "id": "oil-label-22oz",
        "type": "image",
        "src": "assets/media/oil-label-22oz.jpg",
        "alt": "22oz package instructions from the ActiClear uploaded product video",
        "caption": "22oz label detail from brand-uploaded footage. Follow the matching package.",
        "provenance": "brand-uploaded-video-frame",
        "width": 1920,
        "height": 1080
      },
      {
        "id": "oil-demo",
        "type": "video",
        "src": "assets/home/oil-cooled-removal-excerpt-1080p.mp4",
        "poster": "assets/home/oil-cooled-removal-poster-1080p.jpg",
        "alt": "ActiClear cooled oil removal demonstration excerpt",
        "caption": "Actual cooled oil removal, excerpted from an ActiClear 22oz brand video. Follow the current product guide for the full process. The eight-second clip does not indicate solidification time.",
        "provenance": "supplied-brand-video-excerpt",
        "width": 1920,
        "height": 1080,
        "maxDisplayWidth": 960,
        "duration": 8
      },
      {
        "id": "oil-label-video",
        "type": "video",
        "src": "assets/media/oil-label-walkthrough-1080p.mp4",
        "poster": "assets/media/oil-label-poster.jpg",
        "alt": "22oz package label walkthrough excerpt",
        "caption": "30-second silent label walkthrough from ActiClear uploaded footage. Original 1920 x 1080.",
        "provenance": "brand-uploaded-video-excerpt",
        "width": 1920,
        "height": 1080,
        "maxDisplayWidth": 960
      },
      {
        "id": "kitchen-editorial",
        "type": "image",
        "src": "assets/media/kitchen-editorial.png",
        "alt": "kitchen environmental editorial scene",
        "caption": "Illustrative kitchen setting. Original generated editorial image; not a product demonstration.",
        "provenance": "original-generated-environment",
        "width": 1536,
        "height": 1024
      }
    ],
    "pee": [
      {
        "id": "pee-2lb",
        "type": "image",
        "src": "assets/media/pee-2lb-listing.jpg",
        "alt": "pee 2lb package front",
        "variantId": 49913285345526,
        "caption": "2lb package shown. Supplied ActiClear listing image.",
        "provenance": "supplied-amazon-listing-image",
        "width": 2000,
        "height": 2000
      },
      {
        "id": "pee-4lb",
        "type": "image",
        "src": "assets/media/pee-4lb-listing.jpg",
        "alt": "pee 4lb package front",
        "variantId": 49913285378294,
        "caption": "4lb package shown. Supplied ActiClear listing image.",
        "provenance": "supplied-amazon-listing-image",
        "width": 2000,
        "height": 2000
      },
      {
        "id": "travel-editorial",
        "type": "image",
        "src": "assets/media/travel-editorial.png",
        "alt": "travel environmental editorial scene",
        "caption": "Illustrative travel setting. Original generated editorial image; not a product demonstration.",
        "provenance": "original-generated-environment",
        "width": 1536,
        "height": 1024
      }
    ],
    "refill": [
      {
        "id": "refill-5lb",
        "type": "image",
        "src": "assets/media/refill-5lb.png",
        "alt": "5lb Moisture Absorber Refill package",
        "caption": "5lb refill package. Coming soon.",
        "provenance": "existing-verified-package-derivative",
        "width": 441,
        "height": 671
      }
    ]
  },
  "variantImages": {
    "49913176064246": {
      "id": "compact-0.5lb",
      "type": "image",
      "src": "assets/media/compact-0.5lb-restored.svg",
      "alt": "compact 0.5lb package front",
      "variantId": 49913176064246,
      "caption": "0.5lb package. Cap edge restored; original label retained.",
      "provenance": "commercial-restoration",
      "width": 1600,
      "height": 1720,
      "originalSource": "assets/media/compact-0.5lb-listing.jpg",
      "originalSourceProvenance": "supplied-amazon-listing-image",
      "restoration": "AI-generated cap edge only; original JPEG label and body embedded unchanged."
    },
    "49913176097014": {
      "id": "compact-1lb",
      "type": "image",
      "src": "assets/media/compact-1lb-listing.jpg",
      "alt": "compact 1lb package front",
      "variantId": 49913176097014,
      "caption": "1lb package shown. Supplied ActiClear listing image.",
      "provenance": "supplied-amazon-listing-image",
      "width": 1600,
      "height": 1600
    },
    "49913176129782": {
      "id": "compact-2lb",
      "type": "image",
      "src": "assets/media/compact-2lb-listing.jpg",
      "alt": "compact 2lb package front",
      "variantId": 49913176129782,
      "caption": "2lb package shown. Supplied ActiClear listing image.",
      "provenance": "supplied-amazon-listing-image",
      "width": 1600,
      "height": 1600
    },
    "50113861353718": {
      "id": "compact-4lb",
      "type": "image",
      "src": "assets/media/compact-4lb-listing.jpg",
      "alt": "compact 4lb package front",
      "variantId": 50113861353718,
      "caption": "4lb package shown. Supplied ActiClear listing image.",
      "provenance": "supplied-amazon-listing-image",
      "width": 1600,
      "height": 1600
    },
    "49913279021302": {
      "id": "large-5lb",
      "type": "image",
      "src": "assets/media/large-5lb-listing.jpg",
      "alt": "large 5lb package front",
      "variantId": 49913279021302,
      "caption": "5lb package shown. Supplied ActiClear listing image. Original listing artwork; historical upper-band wordmark.",
      "provenance": "supplied-amazon-listing-image",
      "width": 2000,
      "height": 2000
    },
    "49913279054070": {
      "id": "large-15lb",
      "type": "image",
      "src": "assets/media/large-15lb-listing.jpg",
      "alt": "large 15lb package front",
      "variantId": 49913279054070,
      "caption": "15lb package shown. Supplied ActiClear listing image. This 15lb format is shown in a carton.",
      "provenance": "supplied-amazon-listing-image",
      "width": 2000,
      "height": 2000
    },
    "49913164497142": {
      "id": "oil-11oz",
      "type": "image",
      "src": "assets/media/oil-11oz-listing.jpg",
      "alt": "oil 11oz package front",
      "variantId": 49913164497142,
      "caption": "11oz package shown. Supplied ActiClear listing image.",
      "provenance": "supplied-amazon-listing-image",
      "width": 1600,
      "height": 1600
    },
    "49913164529910": {
      "id": "oil-22oz",
      "type": "image",
      "src": "assets/media/oil-22oz-listing.jpg",
      "alt": "oil 22oz package front",
      "variantId": 49913164529910,
      "caption": "22oz package shown. Supplied ActiClear listing image.",
      "provenance": "supplied-amazon-listing-image",
      "width": 2000,
      "height": 2000
    },
    "49913285345526": {
      "id": "pee-2lb",
      "type": "image",
      "src": "assets/media/pee-2lb-listing.jpg",
      "alt": "pee 2lb package front",
      "variantId": 49913285345526,
      "caption": "2lb package shown. Supplied ActiClear listing image.",
      "provenance": "supplied-amazon-listing-image",
      "width": 2000,
      "height": 2000
    },
    "49913285378294": {
      "id": "pee-4lb",
      "type": "image",
      "src": "assets/media/pee-4lb-listing.jpg",
      "alt": "pee 4lb package front",
      "variantId": 49913285378294,
      "caption": "4lb package shown. Supplied ActiClear listing image.",
      "provenance": "supplied-amazon-listing-image",
      "width": 2000,
      "height": 2000
    }
  },
  "scenes": {
    "pond": {
      "id": "pond-editorial",
      "type": "image",
      "src": "assets/media/pond-editorial.png",
      "alt": "pond environmental editorial scene",
      "caption": "Illustrative pond setting. Original generated editorial image; not a product demonstration.",
      "provenance": "original-generated-environment",
      "width": 1536,
      "height": 1024
    },
    "kitchen": {
      "id": "kitchen-editorial",
      "type": "image",
      "src": "assets/media/kitchen-editorial.png",
      "alt": "kitchen environmental editorial scene",
      "caption": "Illustrative kitchen setting. Original generated editorial image; not a product demonstration.",
      "provenance": "original-generated-environment",
      "width": 1536,
      "height": 1024
    },
    "travel": {
      "id": "travel-editorial",
      "type": "image",
      "src": "assets/media/travel-editorial.png",
      "alt": "travel environmental editorial scene",
      "caption": "Illustrative travel setting. Original generated editorial image; not a product demonstration.",
      "provenance": "original-generated-environment",
      "width": 1536,
      "height": 1024
    }
  },
  "mediaUpdatedAt": "2026-09-07T01:34:29.490715+00:00",
  "galleryScenes": {
    "pond": {
      "src": "assets/media/gallery-pond-new.png",
      "alt": "Quiet lake shore with reeds and a timber dock",
      "caption": "By the lake",
      "provenance": "original-generated-editorial-environment"
    },
    "travel": {
      "src": "assets/media/gallery-travel-new.png",
      "alt": "Organized camper storage with towels and a woven basket",
      "caption": "Ready for the road",
      "provenance": "original-generated-editorial-environment"
    }
  },
  "productScenes": {
    "pee": {
      "src": "assets/media/pee-portable-setup.png",
      "alt": "Unused portable sanitation bucket with a clean liner, separate lid and empty scoop",
      "caption": "Illustrative portable setup. Equipment is not included.",
      "provenance": "original-generated-editorial-environment",
      "width": 1536,
      "height": 1024
    }
  }
};
